import GoogleAnalytics from "./implementations/GoogleAnalitycs";
import Analytics from "./Analytics";
import Flowlike from "./implementations/Flowlike";

class AnalyticsBuilder {

  implementations = []

  withGoogleAnalytics = googleAnalyticsAccount => {
    this.implementations.push(new GoogleAnalytics(googleAnalyticsAccount))
    return this
  }

  withFlowlike = () => {
    this.implementations.push(new Flowlike())
    return this
  }

  build = () => new Analytics(this.implementations)

}

export default AnalyticsBuilder